<template>
  <!-- Иконка обязательна: статус не передаётся одним цветом (WCAG 1.4.1). -->
  <span class="inline-flex items-center gap-1.5 px-2 py-1 border rounded-md text-[13px] font-semibold" :class="toneClass" :title="hint">
    <component :is="icon ?? defaultIcon" class="w-4 h-4 shrink-0" aria-hidden="true" />
    <span>{{ label }}</span>
  </span>
</template>

<script setup lang="ts">
import { computed, type Component } from "vue";
import { AlertTriangle, Info, OctagonAlert } from "lucide-vue-next";

const props = defineProps<{ tone: "info" | "warn" | "danger"; icon?: Component; label: string; hint?: string }>();
const toneClass = computed(
  () => ({ info: "border-water text-water bg-sheet", warn: "border-trail text-trail bg-sheet", danger: "border-trail bg-trail text-white" })[props.tone]
);
const defaultIcon = computed(() => ({ info: Info, warn: AlertTriangle, danger: OctagonAlert })[props.tone]);
</script>
